<template>
  <el-row
    :gutter="6"
    class="recommend"
    v-if="
    siteList.length > 0 &&
    siteConfig.displayBanner
    "
  >
    <el-col :span="24">
    <h4 class="recommend-label">
        <span>Recommend</span>
    </h4>
     <div class="categorysite-card" v-for="categorySite in siteList" :key="categorySite.id">
        <el-carousel height="355px" :cardScale="0.8" :interval="5000" type="card"  v-if="device !== 'mobile'">
          <el-carousel-item
            :key="site.id"
            v-for="site in categorySite.sites"
          >
            <router-link :to="'/detail/get/' + site.id" target="_blank">
            <div class="card-bg">
              <el-image
                fit="cover"
                class="carousel-item-image"
                :src="getPictureShowUrl(site.sitePath)"
              ></el-image>
              <div class="carousel-title">
                <span class="article-title">{{ site.siteName }}<svg-icon icon-name="click" class="little" />{{ site.clickCount }}</span>
              </div>
              </div>
            </router-link>
          </el-carousel-item>
        </el-carousel>
         <el-carousel height="255px" type="card"  v-if="device === 'mobile'">
          <el-carousel-item
            :key="site.id"
            v-for="site in categorySite.sites"
          >
            <router-link :to="'/detail/get/' + site.id" target="_blank">
              <el-image
                fit="cover"
                class="carousel-item-image-mobile"
                :src="getPictureShowUrl(site.sitePath)"
              ></el-image>
              <div class="carousel-title-mobile">
                <span class="article-title">{{ site.siteName }}<svg-icon icon-name="click" class="little" />{{ site.clickCount }}</span>

              </div>
            </router-link>
          </el-carousel-item>
        </el-carousel>
     </div>
    </el-col>
  </el-row>
</template>
<script setup>
import { ref, computed } from 'vue'
import { RecommendSiteListBycategory } from '@/api/client/nav'
import { siteDomain } from '@/config/setting.config'
import { getAbout } from '@/api/nav/config'
import { useStore } from 'vuex'
const device = computed(() => store.getters['app/device'])
const firstLoading = ref(true)
const siteList = ref([])
const store = useStore()
const siteConfig = ref({
  displayBanner: undefined
})
async function getFirstRecommendLevelList() {
  firstLoading.value = true
  const { data } = await getAbout(siteDomain)
  if (data) {
    siteConfig.value = data
  }
  const {
    data: { sites }
  } = await RecommendSiteListBycategory(siteDomain)
  siteList.value = sites
  firstLoading.value = false
}
getFirstRecommendLevelList()
</script>
<style lang="scss" scoped>
.recommend-label {
      font-weight: 700;
      padding: 10px 1rem;
      border-radius: 5rem;
      background: linear-gradient(141deg, #1E50FF 20%, #BD00FF 80%);
      width: fit-content;
      color: #fff;
      border-radius: 1rem;
  }
.recommend {
  overflow: hidden;
  .card-bg{
       height: 355px;
       width: 100%;
       display: flex;
       justify-content: center;
       background: rgba(0, 0, 0, 0.5);
        border-radius: 20px;
      .carousel-item-image {
        margin-top:10px;
        background: rgba(0, 0, 0, 0.5);
        display: block;
        height: 300px;
        width: 300px;
        overflow: hidden;
        border-radius: 20px 20px 0px 0px;
      }
  }
  .carousel-item-image-mobile {
    display: block;
    height: 190px;
    width: 190px;
    overflow: hidden;
    border-radius: 20px 20px 0px 0px;
  }

  .carousel-title {
    cursor: pointer;
    position: absolute;
    z-index: 10;
    bottom: 30px;
    height: 40px;
    width: 300px;
    line-height: 40px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 20px 20px;
     .little{
         margin-top:5px;
         width: 1.5em;
         height: 1.5em;
     }
  }

.carousel-title-mobile {
    cursor: pointer;
    position: absolute;
    z-index: 10;
    bottom: 30px;
    height: 40px;
    width: 190px;
    line-height: 40px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 0px 20px 20px;
    .little{
         width: 1.5em;
         height: 1.5em;
     }
  }
  .article-title {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-align: center;
    color: white;
  }

}
</style>
